import React from 'react';
// Preloader is eagerly imported by src/routes/index.jsx (it's the
// fallback for every lazy route), which puts it on the home critical
// path. Replacing MUI's Stack + CircularProgress with a styled div + a
// CSS-animated spinner keeps @mui/material out of the entry graph.
import { styled, keyframes } from '@mui/system';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

const Overlay = styled('div')({
  position: 'fixed',
  inset: 0,
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#fff'
});

// Mirrors MUI's default CircularProgress: 40 px ring, indigo-ish primary
// (#1976d2 is MUI's default). Single-arc visible quadrant via
// border-{top,right} transparent.
const Spinner = styled('div')({
  width: 40,
  height: 40,
  border: '4px solid #1976d2',
  borderTopColor: 'transparent',
  borderRightColor: 'transparent',
  borderRadius: '50%',
  animation: `${spin} 1s linear infinite`
});

const Preloader = () => (
  <Overlay>
    <Spinner role="progressbar" aria-label="Loading" />
  </Overlay>
);

export default Preloader;
